import _ from "lodash";
import { colors } from "Constants";
import {
  PLAN_TYPE_360,
  PLAN_TYPE_360_PILOT,
  PLAN_TYPE_DEMO,
  PLAN_TYPE_FREE,
  PLAN_TYPE_PRO,
  PLAN_TYPE_PRO_PILOT,
} from "Constants/stringConstants";
import { IS_PAID_ORGANIZATION_OPTIONS } from "Tooling/modules/ToolingUtils";

export const getTransitionFilters = transitionAnalytics => {
  return [
    {
      key: "ALL",
      label: "Academic transition",
      value: "",
    },
    {
      key: "IN_30_7",
      label: "30 days left",
      value: "IN_30_7",
      color: colors.textSubtle,
      count: _.get(transitionAnalytics, "30_7", 0),
    },
    {
      key: "IN_7_0",
      label: "7 days left",
      value: "IN_7_0",
      color: colors.textWarning,
      count: _.get(transitionAnalytics, "7_0", 0),
    },
    {
      key: "OVERDUE",
      label: "Overdue",
      value: "OVERDUE",
      color: colors.textCritical,
      count: _.get(transitionAnalytics, "OVERDUE", 0),
    },
  ];
};

export const getCurriculumPlanFilters = subscriptionPlanAnalytics => {
  return [
    {
      key: "ALL",
      label: "All schools",
      value: "",
    },
    {
      key: PLAN_TYPE_DEMO,
      label: `Demo Program(s)`,
      value: "6",
      color: colors.textSubtle,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_DEMO, 0),
    },
    {
      key: PLAN_TYPE_FREE,
      label: `Free Program(s)`,
      value: "1",
      color: colors.textWarning,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_FREE, 0),
    },
    {
      key: PLAN_TYPE_PRO,
      label: `Pro Program(s)`,
      value: "2",
      color: colors.textCritical,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_PRO, 0),
    },
    {
      key: PLAN_TYPE_PRO_PILOT,
      label: `Pro Pilot Program(s)`,
      value: "3",
      color: colors.textSubtle,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_PRO_PILOT, 0),
    },
    {
      key: PLAN_TYPE_360,
      label: `360 Program(s)`,
      value: "4",
      color: colors.violet500,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_360, 0),
    },
    {
      key: PLAN_TYPE_360_PILOT,
      label: `360 Pilot Program(s)`,
      value: "5",
      color: colors.red66,
      count: _.get(subscriptionPlanAnalytics, PLAN_TYPE_360_PILOT, 0),
    },
  ];
};

const getFilters = ({
  tab,
  toddleBuddy,
  plan,
  searchText,
  transitionFilter,
  regionIds,
}) => {
  const filters = {
    searchText,
    feedType: tab === "TRANSITION" ? tab : undefined,
    toddleBuddy: toddleBuddy ? toddleBuddy : undefined,
    planType: plan ? plan : undefined,
    transitionStatus:
      transitionFilter && tab == "TRANSITION" ? transitionFilter : undefined,
    regionIds: !_.isEmpty(regionIds) ? regionIds : undefined,
  };
  return filters;
};

export const getFiltersMemoized = _.memoize(
  params => getFilters(params),
  params => JSON.stringify(params)
);

export const getIsPaidOrganizationValue = ({ isPaidOrganizationKey }) => {
  return _.find(IS_PAID_ORGANIZATION_OPTIONS, {
    key: isPaidOrganizationKey,
  });
};

export const addDisplayOrderIndex = ({ orgDetails }) => {
  const curriculumPrograms = _.get(orgDetails, "curriculumPrograms", []);
  orgDetails.curriculumPrograms = _.map(
    curriculumPrograms,
    (program, index) => {
      program.displayOrder = index;
      return program;
    }
  );
  return orgDetails;
};
